module.exports = __webpack_public_path__ + "static/img/c2.76a3818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insta/c2.jpg
// module id = j9zs
// module chunks = 0